import React from "react";
import { AlertTriangle, X } from "lucide-react";
import { createPortal } from "react-dom";

interface OutOfStockModalProps {
  isOpen: boolean;
  onClose: () => void;
  productName: string;
}

const OutOfStockModal: React.FC<OutOfStockModalProps> = ({
  isOpen,
  onClose,
  productName,
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="modal" onClick={onClose}>
      <div className="modal-body p-6 max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center gap-3">
            <AlertTriangle size={32} className="text-red-600" />
            <h2 className="text-xl font-bold text-primary">Out of Stock</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>

        <div className="space-y-4">
          <p className="text-gray-700">
            <span className="font-semibold">{productName}</span> is currently out of stock.
          </p>
          <p className="text-sm text-gray-600">
            The item's stock amount needs to be updated before it can be added to the order.
          </p>
        </div>

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-primary text-white rounded-md hover:opacity-90"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default OutOfStockModal;

